import type { ReactElement } from "react";

import type { TaskResponse } from "../features/queue/api";
import { useResumeTask } from "../features/queue/useResumeTask";
import { TaskActionButton } from "./TaskActionButton";
import type { TaskActionKeys } from "./TaskActionButton";

// Кнопка «Продолжить» (снятие флага паузы).
// Поведение (409, ошибки, блокировка закрытия окна) — в TaskActionButton.
const KEYS: TaskActionKeys = {
  button: "task.resumeButton",
  inFlight: "task.resumeInFlight",
  confirmTitle: "task.resumeConfirmTitle",
  confirmBody: "task.resumeConfirmBody",
  confirmAccept: "task.resumeConfirmAccept",
  confirmReject: "task.resumeConfirmReject",
  errorTitle: "task.resumeErrorTitle",
};

export function ResumeTaskButton({
  task,
}: {
  readonly task: TaskResponse;
}): ReactElement {
  const mutation = useResumeTask(task.id);
  return <TaskActionButton mutation={mutation} keys={KEYS} />;
}
